function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubOrderHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14450"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11501"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46890",
    d: "m19.981 37.474-1.131-4.528A1.249 1.249 0 0 0 17.637 32H2.364a1.252 1.252 0 0 0-1.214.946L.019 37.474a.611.611 0 0 0-.019.151 3.053 3.053 0 0 0 2.969 3.125 2.917 2.917 0 0 0 2.344-1.209 2.877 2.877 0 0 0 4.688 0 2.877 2.877 0 0 0 4.688 0 2.915 2.915 0 0 0 2.344 1.209A3.053 3.053 0 0 0 20 37.625a.611.611 0 0 0-.019-.151z",
    transform: "translate(0 -31)",
    style: {
      fill: "#2973f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11504"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11503"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46891",
    d: "M47.781 269.919a4.09 4.09 0 0 1-2.344-.735 4.206 4.206 0 0 1-4.687 0 4.206 4.206 0 0 1-4.687 0 4.058 4.058 0 0 1-4.063.346v6.639a1.25 1.25 0 0 0 1.25 1.25h5v-5h5v5h5a1.25 1.25 0 0 0 1.25-1.25v-6.639a4.055 4.055 0 0 1-1.719.389z",
    transform: "translate(-30.75 -258.919)",
    style: {
      fill: "#2973f0"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubOrderHome);
export default __webpack_public_path__ + "static/media/SubOrderHome.a558eb9e8a42cc4319f94bb2367d1762.svg";
export { ForwardRef as ReactComponent };